module.exports = global["jQuery"] = require("-!/app/node_modules/strip-loader/lib/index.js?strip[]=console.log!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/strip-loader/lib?strip[]=console.log!./~/jquery/dist/jquery.js-exposed
// module id = 384
// module chunks = 12 36